import { bool, func, shape } from 'prop-types';
import React, { Fragment, PureComponent } from 'react';
import { TextInput, View } from 'react-native';

import { THEME } from 'reactor/common';
import { Icon, Text, Touchable } from 'reactor/components';
import { TEXTINPUT_DEFAULTS } from './modules';
import styles from './DataRow.style';

const { COLOR } = THEME;

class DataRow extends PureComponent {
  static propTypes = {
    even: bool,
    heading: bool,
    onChange: func,
    onPress: func,
    schema: shape({}),
    sort: shape({}),
    value: shape({}),
  };

  static defaultProps = {
    even: false,
    heading: false,
    onChange: undefined,
    onPress: undefined,
    schema: {},
    sort: undefined,
    value: {},
  };

  _onChange = (field, value) => {
    const { props: { onChange, ...props } } = this;

    onChange({ ...props.value, [field]: value });
  }

  render() {
    const {
      _onChange,
      props: {
        even, heading, onChange, onPress, schema, sort = {}, value, ref,
      },
    } = this;
    const Container = onPress ? Touchable : View;
    const textProps = { subtitle: heading, level: heading ? 3 : 2 };

    return (
      <Container
        onPress={onPress && !heading ? () => onPress(value) : undefined}
        rippleColor={COLOR.PRIMARY}
        ref={ref}
      >
        <View style={[styles.container, styles.row, heading && styles.heading, !heading && even && styles.even]}>
          { Object.keys(schema).map(field => (
            <View
              key={field}
              style={[styles.column, schema[field].style, schema[field].icon && styles.icon]}
            >
              { onChange && !schema[field].disabled
                ? (
                  <TextInput
                    {...TEXTINPUT_DEFAULTS}
                    {...schema[field]}
                    onChangeText={inputValue => _onChange(field, inputValue)}
                    value={value[field] || ''}
                    style={[styles.content, styles.input]}
                  />)
                : (
                  <Touchable onPress={onPress && heading ? () => onPress(field) : undefined} style={styles.row}>
                    <Fragment>
                      <Text
                        {...textProps}
                        color={heading && field === sort.field ? COLOR.PRIMARY : undefined}
                        numberOfLines={1}
                        style={styles.content}
                      >
                        { heading
                          ? (schema[field].label || field).toUpperCase()
                          : (schema[field].icon && <Icon value={schema[field].icon} />) || value[field]
                        }
                      </Text>
                      { heading && field === sort.field && (
                        <Text {...textProps} color={COLOR.PRIMARY}>{sort.asc ? '↓' : '↑'}</Text>)}
                    </Fragment>
                  </Touchable>)
              }

            </View>))}
        </View>
      </Container>
    );
  }
}

export default DataRow;
